<ifc-status-label [status]="statusLabels" [value]="status" [data]="accountStatusIconChipModel"></ifc-status-label>